import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'filterIrrestritas'
})
export class FilterIrrestritasPipe implements PipeTransform {
  transform(items: any[], searchText: string): any[] {
    if (!items) return [];
    if (!searchText) return items;
    searchText = searchText.toLowerCase();
    return items.filter(it => {
      return it.titulo.toLowerCase().includes(searchText);
    });
  }
}